/* TODO: t() */
import React, { PureComponent } from 'react';
import { View, StyleSheet } from 'react-native';

import { Text } from '../../../uiold';

import { FormFieldDefinition } from '../../../../types/shared/FormFieldDefinition';

type Props = {
  definition: FormFieldDefinition;
};

class HeadingElementFormView extends PureComponent<Props> {
  render() {
    let { definition } = this.props;
    // TODO: Better solution here.
    if (definition.type !== 'HeadingElement') {
      return null;
    }
    return (
      <View style={styles.container}>
        <Text type="heading" style={styles.heading}>
          {definition.text}
        </Text>
      </View>
    );
  }
}

let styles = StyleSheet.create({
  container: {
    marginVertical: 5,
    paddingVertical: 10,
  },
  heading: {
    fontWeight: '600',
    paddingHorizontal: 30,
  },
});

export default HeadingElementFormView;
